<template>
  <vue-cookie-accept-decline
    ref="kulapCookieConsent"
    :debug="false"
    :disable-decline="false"
    :show-postpone-button="false"
    element-id="kulap-cookie-consent"
    position="bottom"
    transition-name="slideFromBottom"
    type="bar"
    @clicked-accept="cookieClickedAccept"
    @clicked-decline="cookieClickedDecline"
  >
    <template #postponeContent>&times;</template>

    <template #message>
      {{ bannerText }}
    </template>

    <template #declineContent>Reject all cookies</template>

    <template #acceptContent>Accept all Cookies</template>
  </vue-cookie-accept-decline>
</template>

<script>
import { kulapApi } from '@/resources'
import Service from './service.js'

export default {
  name: 'CookieConsent',
  data () {
    return {
      service: null,
      bannerText: 'We use cookies for better performance and user experience of website usage. View our "Privacy Policy" for more information'
    }
  },

  async created () {
    this.service = new Service({ kulapApi })
  },

  methods: {
    async cookieClickedAccept () {
      try {
        await this.service.postCookieConsent(this.bannerText, 'allow')
      } catch (error) {
        this.$refs.kulapCookieConsent.removeCookie()
      }
    },

    async cookieClickedDecline () {
      try {
        await this.service.postCookieConsent(this.bannerText, 'deny')
      } catch (error) {
        this.$refs.kulapCookieConsent.removeCookie()
      }
    }
  }
}
</script>

<style lang="scss">
.cookie {
  &__bar {
    background-color: white !important;

    &__wrap {
      justify-content: center !important;
    }

    &__content {
      width: unset !important;
      margin-right: 30px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/features/CookieConsent/index.vue